/*
 * @Author: wangweixin
 * @Date: 2018-01-18 17:50:52
 * @Last Modified by: wangweixin
 * @Last Modified time: 2020-05-12 18:39:34
 */
import React, {
  useCallback,
  useRef,
  useImperativeHandle,
  forwardRef,
  useState
} from 'react';
import classNames from 'classnames';
import Icon from '../Icon';
import searchIcon from './images/search.svg';
import clearIcon from './images/clear.svg';
import Item from '../Item';
import { trim } from 'lodash';

function Input(props, ref) {
  const {
    value = '',
    handleChange,
    isSearch,
    clearable,
    type,
    mini,
    radius,
    background,
    hasError: error,
    className,
    header,
    showEye = false,
    ...others
  } = props;

  const [eyeVisible, setEyeVisible] = useState(false);
  const onChange = e => handleChange(e.target.value);
  const inputRef = useRef();
  const onClear = useCallback(() => {
    handleChange('');
    inputRef.current && inputRef.current.focus();
  }, [handleChange]);

  useImperativeHandle(ref, () => ({
    focus: () => inputRef.current?.focus(),
    blur: () => inputRef.current?.blur()
  }));

  const textarea = type === 'textarea';

  const classes = classNames(className, {
    input: true,
    textarea,
    mini,
    radius,
    background,
    error
  });

  if (textarea) {
    return (
      <textarea
        ref={inputRef}
        value={value}
        onChange={onChange}
        className={classes}
        type={type}
        {...others}
      />
    );
  }

  if (isSearch || clearable) {
    const cls = classNames(className, {
      'input-wrapper': true,
      mini,
      search: isSearch,
      clearable
    });
    return (
      <div className={cls}>
        <input
          ref={inputRef}
          value={value}
          onChange={onChange}
          className={classes}
          placeholder={isSearch ? '搜索相关内容' : ''}
          type={type}
          {...others}
        />
        <Item show={isSearch}>
          <Icon className="search-icon" link={searchIcon} />
        </Item>
        <Item show={clearable && trim(value) !== ''}>
          <Icon
            fill="#d6d6d6"
            onClick={onClear}
            className="clear-icon"
            link={clearIcon}
          />
        </Item>
      </div>
    );
  }
  const handleShowPsd = () => {
    setEyeVisible(!eyeVisible);
  };
  let newType = type;
  if (type === 'password') {
    newType = eyeVisible ? 'text' : 'password';
  }
  return (
    <div className="base-input-wrapper">
      {header}
      <input
        ref={inputRef}
        value={value}
        onChange={onChange}
        className={classes}
        type={newType}
        {...others}
      />
      <Item show={showEye}>
        {eyeVisible ? (
          <Icon type="eye" className="eyeIcon" onClick={handleShowPsd} />
        ) : (
          <Icon type="noeye" className="eyeIcon" onClick={handleShowPsd} />
        )}
      </Item>
    </div>
  );
}

export default forwardRef(Input);
